import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { map } from 'rxjs/operators';
import { FileTextToSpeechComponent } from 'src/app/shared/global_components/file-manager/dialog/file-text-to-speech/file-text-to-speech.component';
import { SnackBarItem } from 'src/app/shared/global_components/snack-bar/snack-bar-item';
import { BaseClass } from 'src/app/shared/models/base-class';
import { LayoutService } from 'src/app/shared/services/common/layout.service';
import { FileService } from 'src/app/shared/services/rest/file.service';

@Component({
  selector: 'app-user-tts',
  templateUrl: './user-tts.component.html',
  styleUrls: ['./user-tts.component.scss']
})
export class UserTtsComponent extends BaseClass implements OnInit, OnDestroy {
  public ttsItems: any[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<UserTtsComponent>,
    public layoutService: LayoutService,
    public fileService: FileService,
  ) { super() }

  ngOnInit(): void {
    console.log("UserTtsComponent", this.data)
    this.getUserSettingTTS();
  }

  getUserSettingTTS(isInit:boolean = true) {
    this.attachSubscriptions(
      this.fileService.getUserSettingTTS({'per-page': 200, company_id: this.data.company.id, employee_id: this.data.employee.id}).pipe(
        map(x => x.body)
      ).subscribe(resp => {
        this.ttsItems = resp;
        if (isInit) {
          if (this.ttsItems.length == 0) {
            this.userTTS();
          }
        }
      })
    )
  }

  deleteTTS(id, i) {
    this.attachSubscriptions(
      this.fileService.deletUserSettingTTS(id, this.data.company.id).subscribe(resp => {
        this.ttsItems.splice(i, 1)
      })
    )
  }

  close() {
    this.dialogRef.close({event: "close", data: false})
  }

  userTTS(setting?) {
    const dialogRef = this.dialog.open(FileTextToSpeechComponent, {
      backdropClass: ['speech_file_backdrop'],
      panelClass: ['speech_file_pane'],
      data: {
        company: this.data.company,
        employee: this.data.employee,
        user: this.data.user,
        setting: setting
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      this.getUserSettingTTS(false);
    })
  }

  ngOnDestroy(): void {
    this.clearSubscriptions()
  }
}
